module.exports = __webpack_public_path__ + "r-v3/img/cam_on_white.da9115f4.svg";